var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2218_6781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4623 24.8615L52.203 29.9045L63.5886 35.3313L69.3613 20.001L52.0396 9.99858L34.7178 0L17.3999 9.99858L0.078125 20.001L9.89049 34.1494L25.9771 24.8615L34.7178 19.8147L43.4623 24.8615Z",
    fill: "#6A5391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9788 55.1384L0 40.1387L0.0798062 59.999L17.4015 69.9976L34.7195 79.9962L52.0412 69.9976L34.7195 60.1852L25.9788 55.1384Z",
    fill: "#D2AE2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2039 50.0907L69.3622 40.1872V40.001V20L52.2039 29.9036L34.7188 40.001V60.1881L52.2039 50.0907Z",
    fill: "#8E64A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2365 40.001V29.9036L0.078125 20V40.001V60.0019L17.2365 50.0907V40.001Z",
    fill: "#C59535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2218_6781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.363,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cdf9fa274529c05813052bf5bf5c4faa.svg";
export { ForwardRef as ReactComponent };